/*eslint-disable */
import React, { useState } from "react";
import { Button, Modal, Form as FormUi, Icon } from "semantic-ui-react";
import { translate } from "react-i18next";

const ModalReason = ({ rejectReason, t }) => {
  const [modalOpen, setmodalOpen] = useState(false);

  let handleOpen = () => setmodalOpen(true);
  let handleClose = () => setmodalOpen(false);

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        size="tiny"
        trigger={
          <Button
            type="button"
            onClick={handleOpen}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            <Icon name="sticky note" />
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">{t("title") || "Reject Reason"}</Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            <div className="ui form">
              <p>{rejectReason}</p>
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            type="submit"
            onClick={handleClose}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("action_button.close") || "Close"}
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default translate("reject_reason")(ModalReason);
